import { chartHeader } from "./chartHeader";

export class RecommendedAction {

    data:string[];
    header:chartHeader[];

    constructor() {
        this.data = [];
        this.header = [];
    }

}